import {
  PartialQuestionnaire,
  QuestionnaireQuestions,
  Rule,
} from '../../models';
import { findDependents } from '../findDependents';

/**
 *
 * QNR-Framework helper functionality to revmove all dependent answers.
 * This function will remove all dependent (and their retrospective dependent) answers.
 *
 */
export const removeDependentAnswers = <
  Questionnaire extends QuestionnaireQuestions,
  GroupId,
  ExtendedComponentTypes
>(
  questionnaire: PartialQuestionnaire<
    Questionnaire,
    GroupId,
    ExtendedComponentTypes
  >,
  rules: Rule<Questionnaire>[],
  answers: Partial<Questionnaire>,
  questionId: keyof Questionnaire
): Partial<Questionnaire> => {
  const dependentQuestionIds = findDependents(questionnaire, rules, questionId);
  return Object.entries(answers).reduce((acc, [questionId, value]) => {
    if (!dependentQuestionIds.includes(questionId)) {
      return {
        ...acc,
        [questionId]: value,
      };
    }
    return acc;
  }, {});
};
